import { useSyncExternalStore } from "react";

/** `true` while the media query matches. SSR/jsdom without matchMedia → `false`. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = typeof window !== "undefined" ? window.matchMedia?.(query) : undefined;
      m?.addEventListener?.("change", cb);
      return () => m?.removeEventListener?.("change", cb);
    },
    () => (typeof window !== "undefined" ? !!window.matchMedia?.(query)?.matches : false),
    () => false,
  );
}

/** Phones (under the `sm` breakpoint): side panels become bottom drawers, toasts move to the bottom. */
export const usePhone = () => useMediaQuery("(max-width: 639px)");
